import * as Preact from "preact"
import "@frog/source/views/dev/DevEncounterEditorScreen.less"
import App from "@frog/source/models/App.js"
import Dev from "@frog/source/models/dev/Dev.js"

import Navigation from "@frog/source/engine/navigating/Navigation.js"
import games from "@frog/source/data/games"

import Camera from "@frog/source/views/components/Camera.jsx"
import Cursor from "@frog/source/views/components/Cursor.jsx"
import EncounterArea from "@frog/source/views/components/EncounterArea.jsx"
import EditorModeSplash from "@frog/source/views/components/EditorModeSplash.jsx"

export default class DevEncounterEditorScreen {
    render() {
        if(App.game == undefined) {
            const game = games[Object.keys(games)[0]]
            return (
                <div class="DevEncounterDesignScreen">
                    <div class="Header">Encounters</div>
                    <span onClick={() => Navigation.go("/games/" + game.slug + "/chapters/" + (game.firstChapterKey || "1"))}>Please load a game</span>
                </div>
            )
        }

        return (
            <div class="DevEncounterDesignScreen"
                onMouseDown={(event) => Dev.devSelection.start()}
                onMouseUp={(event) => Dev.devSelection.finish()}
                onWheel={(event) => Dev.devSelection.wheel(event)}>
                <EditorModeSplash text="Geography Editor"/>
                <Camera chapter={App.game.chapter}>
                    <Cursor stage={Dev.loadedProtostage}/>
                    <WorldImage stage={Dev.loadedProtostage}/>
                    {Object.values(Dev.loadedProtostage.world.zones).map((encounter) => <Encounter encounter={encounter}/>)}
                </Camera>
            </div>
        )
    }
}

class Encounter {
    constructor(props) {
        let vertices = props.encounter.points
        if(vertices == undefined) {
            const x1 = props.encounter.x
            const y1 = props.encounter.y
            const x2 = props.encounter.x + props.encounter.width
            const y2 = props.encounter.y + props.encounter.height
            vertices = [
                {"x": x1, "y": y1},
                {"x": x2, "y": y1},
                {"x": x2, "y": y2},
                {"x": x1, "y": y2},
            ]
            props.encounter.points = vertices
        }
    }
    render() {
        return (
            <div class="Encounter"
                isSelected={this.isSelected + ""}
                isHovered={this.isHovered + ""}>
                <EncounterArea class="Area" stage={Dev.loadedProtostage} encounter={this.props.encounter}/>
                {this.props.encounter.points.map((vertex, index) => <EncounterEdge pointA={vertex} pointB={this.props.encounter.points[(index + 1) % this.props.encounter.points.length]}/>)}
                {this.props.encounter.points.map((vertex) => <EncounterVertex point={vertex}/>)}
            </div>
        )
    }
    get isSelected() {
        return this.props.encounter.slug == Dev.devSelection.selectedEncounterKey
    }
    get isHovered() {
        return this.props.encounter.slug == Dev.devSelection.hoveredEncounterKey
            || this.props.encounter.slug == Dev.devSelection.listHoveredEncounterKey
    }
}

class WorldImage {
    render() {
        if(this.props.stage.images != undefined) {
            return this.props.stage.images.map((image, index) => {
                return (
                    <div class="WorldImage" style={{
                        "background-image": "url(" + (image.url || image) + ")",
                        "width": this.props.stage.world.width + "em",
                        "height": this.props.stage.world.height + "em",
                        "z-index": 1 + (index * 10),
                        "mix-blend-mode": image.effect,
                    }}/>
                )
            })
        }
        return (
            <div class="WorldImage" style={{
                "background-image": "url(" + this.props.stage.image + ")",
                "width": this.props.stage.world.width + "em",
                "height": this.props.stage.world.height + "em",
            }}>
                {this.encounters}
            </div>
        )
    }
}

const VERTEX_SIZE = 0.4
class EncounterVertex {
    render() {
        return (
            <div class="Vertex" isSelected={this.isSelected} style={{
                "width": VERTEX_SIZE + "em",
                "height": VERTEX_SIZE + "em",
                "left": this.props.point.x - VERTEX_SIZE/2 + "em",
                "top": this.props.point.y - VERTEX_SIZE/2 + "em",
                "clip-path": "circle(50%)",
            }}/>
        )
    }
    get isSelected() {
        return this.props.point.key == Dev.devSelection.selectedVertexKey
            || Dev.devSelection.multiselectedVertexKeys.includes(this.props.point.key)
    }
}
const EDGE_THICKNESS = 0.1
class EncounterEdge {
    render() {
        const width = this.props.pointB.x - this.props.pointA.x
        const height = this.props.pointB.y - this.props.pointA.y
        const style = {
            "left": this.props.pointA.x + "em",
            "top": this.props.pointA.y + "em",
            "width": Math.sqrt(width * width + height * height) + "em",
            "height": EDGE_THICKNESS + "em",
            "transform-origin": "left",
            "transform": "rotate(" + Math.atan2(height, width) + "rad)",
        }
        return <div class="Edge" isSelected={this.isSelected} style={style}/>
    }
    get isSelected() {
        return Dev.devSelection.multiselectedVertexKeys.includes(this.props.pointA.key)
            && Dev.devSelection.multiselectedVertexKeys.includes(this.props.pointB.key)
    }
}
